<div class="generalPage" aria-label="help browsing" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont generalHeader" role="heading">{{cap_header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="cap_desc"></p>
    <p class="answer font-24 content-blue width-100 bold mb-invert-12 pb-heading" role="heading">{{cap_para1header}}</p>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="cap_para1body"></p>
  </div>
</div>
